import { useField, useFormikContext } from 'formik';
import React from 'react';
import { FormikTextField } from '../../Components/FormikFields/FormikTextField';
import { StepSelector } from '../../Components/StepSelector/StepSelector';
import { StepSelectorGroup } from '../../Components/StepSelector/StepSelectorGroup';
import styles from './MedicationListInformationStep.module.css';
export var MedicationListFormErrors_TypeMissing = 'formMissingType';
export var createMedicationListStepFields = [
    'name',
    'isScopeOfPracticeList',
    'isFormulary',
    'isDefaultList',
    MedicationListFormErrors_TypeMissing
];
export var MedicationListInformationStep = function (props) {
    var _a;
    var _b = useFormikContext(), values = _b.values, setFieldValue = _b.setFieldValue, setFieldError = _b.setFieldError, setFieldTouched = _b.setFieldTouched;
    var scopeOfPracticeField = useField('isScopeOfPracticeList');
    var formularyField = useField('isFormulary');
    var defaultListField = useField('isDefaultList');
    var scopeOfPracticeError = scopeOfPracticeField[1].touched ? scopeOfPracticeField[1].error : '';
    var formularyError = formularyField[1].touched ? formularyField[1].error : '';
    var defaultListError = defaultListField[1].touched ? defaultListField[1].error : '';
    var form = useFormikContext();
    var allTypesTouched = scopeOfPracticeField[1].touched || formularyField[1].touched || defaultListField[1].touched;
    // Typescript shenanigans to make it able to pluck the error off the errors object.
    var typesErrors = allTypesTouched
        ? form.errors[MedicationListFormErrors_TypeMissing]
        : '';
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.listName },
            React.createElement(FormikTextField, { label: 'List name', name: 'name', testId: 'list-name', required: true })),
        React.createElement("div", { className: styles.listHeader }, "Type of medication list"),
        React.createElement(StepSelectorGroup, null,
            React.createElement(StepSelector, { useCheckbox: true, value: values.isScopeOfPracticeList, active: values.isScopeOfPracticeList, onClick: function (newValue) {
                    setFieldValue('isScopeOfPracticeList', newValue);
                    setFieldError('isScopeOfPracticeList', '');
                    setFieldTouched('isScopeOfPracticeList', true, false);
                }, testId: 'scope-of-practice', text: 'Scope of practice', info: "A list that includes medications for which a non-prescribing provider can create medication orders. Medications outside of this list require a " + ((_a = props.verbalOrderTerm) === null || _a === void 0 ? void 0 : _a.singularTerm) + ".", error: scopeOfPracticeError }),
            React.createElement(StepSelector, { useCheckbox: true, value: values.isFormulary, active: values.isFormulary, onClick: function (newValue) {
                    setFieldValue('isFormulary', newValue);
                    setFieldError('isFormulary', '');
                    setFieldTouched('isFormulary', true, false);
                }, testId: 'formulary', text: 'Formulary', info: 'A limited list of medications available to particular provider specialties.', error: formularyError }),
            React.createElement(StepSelector, { useCheckbox: true, value: values.isDefaultList, active: values.isDefaultList, onClick: function (newValue) {
                    setFieldValue('isDefaultList', newValue);
                    setFieldError('isDefaultList', '');
                    setFieldTouched('isDefaultList', true, false);
                }, testId: 'default', text: 'Default list', info: 'A list of medications which share common prescribing attributes.', error: defaultListError }),
            !!typesErrors && React.createElement("div", { className: styles.errorText }, typesErrors))));
};
